/**
 * Utility for resolving company logo URLs from member/registration data.
 */

const getApiBase = () => {
  if (process.env.REACT_APP_BACKEND_URL) return process.env.REACT_APP_BACKEND_URL;
  if (typeof window === 'undefined') return '';

  const hostname = window.location.hostname;
  if (['oneglobealliance.com', 'www.oneglobealliance.com', 'uat.oneglobealliance.com', 'kyc.boltcargo.com'].includes(hostname)) {
    return window.location.origin;
  }
  return 'http://localhost:8001';
};

const API_BASE = getApiBase();

/**
 * Get the full URL for a company logo from member or profile data.
 * Handles both string URLs and object format { file_url, url }.
 * @param {object} data - Member or profile object with company_logo
 * @returns {string|null} Full logo URL or null if not available
 */
export function getCompanyLogoUrl(data) {
  let logoUrl = data?.company_logo;
  if (!logoUrl) return null;
  if (typeof logoUrl === 'object') {
    logoUrl = logoUrl.file_url || logoUrl.url;
  }
  if (!logoUrl) return null;
  if (logoUrl.startsWith('/') && !logoUrl.startsWith('http')) {
    logoUrl = `${API_BASE}${logoUrl}`;
  }
  return logoUrl;
}

/**
 * Get logo URL or fallback to DiceBear initials avatar.
 * @param {object} data - Member or profile object
 * @param {string} seed - Fallback seed for initials (e.g. company_name)
 */
export function getLogoOrInitials(data, seed) {
  const url = getCompanyLogoUrl(data);
  if (url) return url;
  return `https://api.dicebear.com/7.x/initials/svg?seed=${encodeURIComponent(seed || data?.company_name || 'Company')}`;
}
